import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AppDispatch } from 'store';
import { RewardsBundle } from 'api/optimalprint-sdk.d';
import { setRewardsSummary } from '../slice';

const fetchRewardsSummaryOperation = () => async (dispatch: AppDispatch) => {
  const rewardsSummaryResponse = await apiRequest<RewardsBundle.Entity.API.RewardsSummaryV1.RewardsSummaryResponse>(
    endpoints.rewardsSummaryV1,
    {},
    HttpMethods.GET,
    'data',
  );
  dispatch(setRewardsSummary(rewardsSummaryResponse));
};

export default fetchRewardsSummaryOperation;
